import { graphql } from '@/generated/gql';

export const FILE_ATTACHMENT_FRAGMENT = graphql(/* GraphQL */ `
  fragment FileAttachment on TsrctAttachment {
    id
    createdAt
    updatedAt
    parent {
      id
      variant
    }
    visibilities {
      id
      variant
    }
    classification
    uploadedBy {
      variant
    }
  }
`);

export const FILE_ATTACHMENTS_MUTATION = graphql(/* GraphQL */ `
  mutation FileAttachmentsUpdate($data: TsrctAttachmentMutationInput!) {
    tesseract {
      attachment {
        update(data: $data) {
          parent {
            id
            variant
          }
          attachments {
            ...FileAttachment
          }
        }
      }
    }
  }
`);
